import { Field } from '@chakra-ui/react'
import { TextColors } from 'commons/design-system/tokens'
import { useTranslation } from 'react-i18next'

type Props = {
	errors: (string | Error)[]
	withoutBorder?: boolean
}

export const FormErrors = ({ errors, withoutBorder = false }: Props) => {
	const { t } = useTranslation()

	if (!errors || errors.length === 0) {
		return null
	}

	const errorMessages = errors.map((error) => {
		// Handle both string errors and Error objects
		const errorText = typeof error === 'string' ? error : error?.message
		// If error message is a translation key, translate it
		if (errorText && errorText.startsWith('phone_form.')) {
			return t(errorText)
		}
		return errorText
	})

	return (
		<Field.ErrorText
			fontFamily='Montserrat'
			color={TextColors.STATUS_ERROR}
			borderTop={withoutBorder ? 'none' : `1px solid ${TextColors.STATUS_ERROR}`}
			pt={withoutBorder ? 0 : 2}
			mt={1}
		>
			{errorMessages.join(', ')}
		</Field.ErrorText>
	)
}
